import * as React from 'react';
import PropTypes from 'prop-types';
import { Button, FormItemInput, Checkbox, FlexLayout } from '@nutanix-ui/prism-reactjs';

// TO-DO: CHANGE LATER TO USE ntnx-I18n library
import getI18nService from '../../i18n/I18n';
import './LoginPage.less';

const i18n = getI18nService();

class IDPLogin extends React.Component {
    static propTypes = {
        rowsData: PropTypes.array,
        apiFetchRequest: PropTypes.func,
        isIDPSearch: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedRow: null,
            rowsData: props.rowsData,
            name: localStorage.getItem('myIdp'),
            rememberIdp: localStorage.getItem('rememberIdp') === 'true',
        };
    }

    /**
     * Handles inputs change to set values in state
     * @param {Object} evt - Input event.
     * @returns {void}
     */
    handleInputChange = evt => {
        const { value, name } = evt.target;
        this.setState({ [name]: value });
        if (this.state.rememberIdp) {
            localStorage.setItem('myIdp', value);
        }
    };

    handleOnClick = () => {
        const { name } = this.state;
        this.props.isIDPSearch(name);
        this.props.apiFetchRequest({
            endpoint: 'GET_CONNECTORS',
            body: {
                name,
            },
        });
    };

    handleRememberMe = event => {
        const isChecked = event.target.checked;
        localStorage.setItem('rememberIdp', isChecked);
        localStorage.setItem('myIdp', this.state.name);
        this.setState({
            rememberIdp: isChecked,
        });

        if (!isChecked) {
            localStorage.removeItem('myIdp');
        }
    };

    render() {
        const connector = this.state.selectedRow || {};

        return (
            <React.Fragment>
                <FlexLayout itemSpacing="15px" flexDirection="column">
                    <FormItemInput
                        id="idpName"
                        data-test="loginIdpName"
                        data-testid="loginIdpName"
                        value={this.state.name}
                        label={i18n.t('Providers.identityProviderName')}
                        placeholder={i18n.t('Providers.authProviderLoginMessage')}
                        name="name"
                        onChange={this.handleInputChange}
                    />
                    <Checkbox
                        id="remember-idp"
                        data-testid="rememberIdp"
                        className="remember-me-checkbox"
                        checked={this.state.rememberIdp}
                        label={i18n.t('Providers.rememberMyIdPName')}
                        onChange={this.handleRememberMe}
                    />
                </FlexLayout>
                <Button
                    fullWidth={true}
                    data-test="providersButtonIDPLogin"
                    data-testid="providersButtonIDPLogin"
                    id={connector.id || 1}
                    key={1}
                    disabled={!this.state.name}
                    onClick={this.handleOnClick}
                >
                    <p className="overflow-ellipsis">{i18n.t('Providers.next')}</p>
                </Button>
            </React.Fragment>
        );
    }
}

export default IDPLogin;
